<template>
  <v-container class="pa-0 ma-0">
    <v-row class="mt-5">
      <v-col class="text-center">
        <h1>{{ $t('content.jobAdvertisement.label') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs
          color="grey lighten-5"
          slider-color="primary"
          active-class="primary"
          grow
          :vertical="$vuetify.breakpoint.smAndDown"
          :hide-slider="$vuetify.breakpoint.smAndDown"
          :centered="$vuetify.breakpoint.mdAndUp"
        >
          <v-tab @click="$vuetify.goTo('#section-1')">
            {{ $t('content.howItWorksEmployer.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-2')">
            {{ $t('content.advantagesEmployer.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-3')">
            {{ $t('content.offerEmployers.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-4')">
            {{ $t('content.employersSays.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-5')">
            {{ $t('content.faqsEmployers.label') }}
          </v-tab>
        </v-tabs>
        <v-divider/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl>
          <v-row>
            <v-col class="text-center">
              <div class="responsive-video-container">
                <iframe
                  class="responsive-video"
                  :src="`https://www.youtube.com/embed/${youtubeVideoId}?rel=0&showinfo=0`"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen>
                </iframe>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">

        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-1">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.howItWorksEmployer.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title>
                  <h3>{{ $t('content.howItWorksEmployer.fillOpenJobs.label') }}</h3>
                </v-card-title>
                <v-card-text>
                  <ol>
                    <li v-html="$t('content.howItWorksEmployer.fillOpenJobs.text1')"/>
                    <li v-html="$t('content.howItWorksEmployer.fillOpenJobs.text2')"/>
                    <li v-html="$t('content.howItWorksEmployer.fillOpenJobs.text3')"/>
                    <li v-html="$t('content.howItWorksEmployer.fillOpenJobs.text4')"/>
                    <li v-html="$t('content.howItWorksEmployer.fillOpenJobs.text5')"/>
                  </ol>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title>
                  <h3>{{ $t('content.howItWorksEmployer.offerPerspective.label') }}</h3>
                </v-card-title>
                <v-card-text>
                  <ol>
                    <li v-html="$t('content.howItWorksEmployer.offerPerspective.text1')"/>
                    <li v-html="$t('content.howItWorksEmployer.offerPerspective.text2')"/>
                  </ol>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="my-5 py-5"/>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-2">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.advantagesEmployer.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title>
                  <h3>{{ $t('content.advantagesEmployer.forYouremployees.label') }}</h3>
                </v-card-title>
                <v-card-text>
                  <ol>
                    <li v-html="$t('content.advantagesEmployer.forYouremployees.text1')"/>
                    <li v-html="$t('content.advantagesEmployer.forYouremployees.text2')"/>
                    <li>
                      <i18n path="content.advantagesEmployer.forYouremployees.text3">
                        <template #linebreak><br></template>
                        <template #action>
                          <router-link
                            :to="{ name: 'page.employee.further-education', params: { lang: language } }"
                          >
                            {{ $t('content.advantagesEmployer.forYouremployees.text3link') }}
                          </router-link>
                        </template>
                      </i18n>
                    </li>
                    <li>
                      <i18n path="content.advantagesEmployer.forYouremployees.text4">
                        <template #linebreak><br></template>
                        <template #action>
                          <router-link
                            :to="{ name: 'page.employer.seco-pilot', params: { lang: language } }"
                          >
                            {{ $t('content.advantagesEmployer.forYouremployees.text4link') }}
                          </router-link>
                        </template>
                      </i18n>
                    </li>
                  </ol>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title>
                  <h3>{{ $t('content.advantagesEmployer.yours.label') }}</h3>
                </v-card-title>
                <v-card-text>
                  <ol>
                    <li v-html="$t('content.advantagesEmployer.yours.text1')"/>
                    <li v-html="$t('content.advantagesEmployer.yours.text2')"/>
                    <li v-html="$t('content.advantagesEmployer.yours.text3')"/>
                  </ol>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="my-5 py-5"/>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-3">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.offerEmployers.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              :cols="12" :sm="8"
              class="text-center"
            >
              {{ $t('content.offerEmployers.text') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="(offer, index) in offers" :key="index"
              :cols="12"
              :sm="6"
              :lg="3"
            >
              <v-card flat>
                <v-card-title class="d-flex justify-center text-center">
                  <span>{{ offer.title }}<br>
                  {{ offer.subtitle }}</span>
                </v-card-title>
                <v-card-text>
                  <div class="text-center">
                  <span class="headline price">{{ offer.price }}</span> {{ offer.priceText }}
                  </div>
                </v-card-text>
                <v-card-text v-html="offer.description" />
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="12" class="d-flex justify-center">
              <div class="text-center">
                *{{ $t('content.offerEmployers.sizes.employeesPeakSeason') }}
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="my-5 py-5"/>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-4">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.employersSays.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8" class="d-flex justify-center">
              <v-carousel
                :value="startQuote"
                interval="20000"
                :show-arrows="true"
                hide-delimiters
              >
                <v-carousel-item
                  v-for="(item, index) in quotes"
                  :key="index"
                >
                  <v-sheet
                    height="100%"
                    tile
                    light
                    color="transparent"
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                      <v-col :cols="10" class="text-center">
                        <v-avatar size="200" class="mb-5">
                          <v-img :src="`${imagePath}${item.img}`"/>
                        </v-avatar>
                        <div>
                          <strong v-html="item.person"></strong><br>
                          <div v-html="item.text"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-container>
        <v-divider class="my-5 py-5"/>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-5">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.faqsEmployers.label') }}</h2>
            </v-col>
          </v-row>
          <v-row v-for="(section, index) in faqs" :key="index" justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title class="justify-center text-center pb-0">
                  <h3>{{ section.label }}</h3>
                </v-card-title>
                <v-card-text class="px-0 mx-0 pb-0">
                  <v-expansion-panels accordion flat>
                    <v-expansion-panel
                      v-for="(item, index) in section.items" :key="index"
                      class="elevation-0"
                      flat
                    >
                      <v-expansion-panel-header>
                        {{ item.question }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-if="item.link">
                          <i18n :path="item.answer" v-if="item.type === 'link'">
                            <template #linebreak><br></template>
                            <template #action>
                              <router-link
                                :to="{ name: item.routeName, hash: item.hash, params: { lang: language } }"
                              >
                                {{ $t(`${item.answer}link`) }}
                              </router-link>
                            </template>
                          </i18n>
                          <i18n :path="item.answer" v-if="item.type === 'contact'">
                            <a @click="openContactFormDialog()">
                              {{ $t(`${item.answer}link`) }}
                            </a>
                          </i18n>
                        </div>
                        <div v-else v-html="item.answer"></div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');
const { mapState: mapCompanyState } = createNamespacedHelpers('company');

export default {
  name: 'JobAdvertisement',
  data() {
    return {
      startQuote: 1,
      startOfferPanel: 2,
      imagePath: '/static/quotes/employers/',
      activeSubscription: 2,
    };
  },
  created() {
    this.generateStartQuote();
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  computed: {
    ...mapUserState([
      'authUser',
      'language',
    ]),
    ...mapCompanyState([
      'companies',
    ]),
    youtubeVideoId() {
      if (this.$i18n.locale === 'it') {
        return 'TD1GA2NVZmw';
      }
      return 'gdfD-uMH0xE';
    },
    offers() {
      const offers = [
        {
          title: this.$i18n.t('content.offerEmployers.sizes.micro'),
          subtitle: this.$i18n.t('content.offerEmployers.sizes.microSubtitle'),
          price: '49.90',
          priceText: this.$i18n.t('content.offerEmployers.sizes.priceText'),
          description: this.$i18n.t('content.offerEmployers.sizes.text'),
        },
        {
          title: this.$i18n.t('content.offerEmployers.sizes.small'),
          subtitle: this.$i18n.t('content.offerEmployers.sizes.smallSubtitle'),
          price: '66.90',
          priceText: this.$i18n.t('content.offerEmployers.sizes.priceText'),
          description: this.$i18n.t('content.offerEmployers.sizes.text'),
        },
        {
          title: this.$i18n.t('content.offerEmployers.sizes.medium'),
          subtitle: this.$i18n.t('content.offerEmployers.sizes.mediumSubtitle'),
          price: '99.90',
          priceText: this.$i18n.t('content.offerEmployers.sizes.priceText'),
          description: this.$i18n.t('content.offerEmployers.sizes.text'),
        },
        {
          title: this.$i18n.t('content.offerEmployers.sizes.large'),
          subtitle: this.$i18n.t('content.offerEmployers.sizes.largeSubtitle'),
          price: '124.90',
          priceText: this.$i18n.t('content.offerEmployers.sizes.priceText'),
          description: this.$i18n.t('content.offerEmployers.sizes.largeText'),
        },
      ];
      return offers;
    },
    quotes() {
      const quotes = [
        {
          person: this.$i18n.t('content.employersSays.1.person'),
          text: this.$i18n.t('content.employersSays.1.text'),
          img: 'corinne-denzler.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.2.person'),
          text: this.$i18n.t('content.employersSays.2.text'),
          img: 'marcel-kraehenmann.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.3.person'),
          text: this.$i18n.t('content.employersSays.3.text'),
          img: 'andreas-claudine-zuellig.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.4.person'),
          text: this.$i18n.t('content.employersSays.4.text'),
          img: 'franzisca-rechsteiner.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.5.person'),
          text: this.$i18n.t('content.employersSays.5.text'),
          img: 'regula-peter.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.6.person'),
          text: this.$i18n.t('content.employersSays.6.text'),
          img: 'federico-haas.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.7.person'),
          text: this.$i18n.t('content.employersSays.7.text'),
          img: 'esther-oubina.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.8.person'),
          text: this.$i18n.t('content.employersSays.8.text'),
          img: 'thomas-gruber.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.9.person'),
          text: this.$i18n.t('content.employersSays.9.text'),
          img: 'sandy-stoeckenius.jpg',
          url: '',
        },
        {
          person: this.$i18n.t('content.employersSays.10.person'),
          text: this.$i18n.t('content.employersSays.10.text'),
          img: 'ralph-treuthardt.jpg',
          url: '',
          show: false,
        },
        {
          person: this.$i18n.t('content.employersSays.11.person'),
          text: this.$i18n.t('content.employersSays.11.text'),
          img: 'fabian-mauerhofer.jpg',
          url: '',
        },
      ];
      return quotes.filter((quote) => quote.show !== false);
    },
    faqs() {
      const faqs = [
        {
          label: this.$i18n.t('content.faqsEmployers.cooperations.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployers.cooperations.1q'),
              answer: this.$i18n.t('content.faqsEmployers.cooperations.1a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.cooperations.2q'),
              answer: this.$i18n.t('content.faqsEmployers.cooperations.2a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.cooperations.3q'),
              answer: this.$i18n.t('content.faqsEmployers.cooperations.3a'),
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployers.notifications.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployers.notifications.1q'),
              answer: this.$i18n.t('content.faqsEmployers.notifications.1a'),
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployers.jobAdvertisements.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.1q'),
              answer: this.$i18n.t('content.faqsEmployers.jobAdvertisements.1a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.2q'),
              answer: this.$i18n.t('content.faqsEmployers.jobAdvertisements.2a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.3q'),
              answer: this.$i18n.t('content.faqsEmployers.jobAdvertisements.3a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.4q'),
              answer: this.$i18n.t('content.faqsEmployers.jobAdvertisements.4a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.5q'),
              answer: 'content.faqsEmployers.jobAdvertisements.5a',
              link: true,
              type: 'contact',
            },
            {
              question: this.$i18n.t('content.faqsEmployers.jobAdvertisements.6q'),
              answer: 'content.faqsEmployers.jobAdvertisements.6a',
              link: true,
              type: 'contact',
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployers.paymentTerms.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.1q'),
              answer: 'content.faqsEmployers.paymentTerms.1a',
              link: true,
              type: 'link',
              routeName: 'page.job-advertisement',
              hash: '#section-3',
            },
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.2q'),
              answer: this.$i18n.t('content.faqsEmployers.paymentTerms.2a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.3q'),
              answer: this.$i18n.t('content.faqsEmployers.paymentTerms.3a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.4q'),
              answer: this.$i18n.t('content.faqsEmployers.paymentTerms.4a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.5q'),
              answer: this.$i18n.t('content.faqsEmployers.paymentTerms.5a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployers.paymentTerms.6q'),
              answer: 'content.faqsEmployers.paymentTerms.6a',
              link: true,
              type: 'link',
              routeName: 'page.job-advertisement',
              hash: '#section-3',
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployers.deleteAccount.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployers.deleteAccount.1q'),
              answer: 'content.faqsEmployers.deleteAccount.1a',
              link: true,
              type: 'contact',
            },
          ],
        },
      ];
      return faqs;
    },
  },
  methods: {
    scrollToSection(section) {
      if (section !== '') {
        this.$vuetify.goTo(section);
      }
    },
    scrollToHash() {
      this.scrollToSection(this.$route.hash);
    },
    generateStartQuote() {
      this.startQuote = Math.floor(Math.random() * this.quotes.length) + 1;
    },

    openContactFormDialog() {
      if (this.authUser) {
        this.$eventBus.$emit('show-contact-form-dialog');
      } else {
        this.$eventBus.$emit('show-user-login-dialog');
      }
    },
    openNewsletterRegistrationDialog() {
      this.$eventBus.$emit('show-newsletter-registration-dialog');
    },
  },
  watch: {
    $route: 'scrollToHash',
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-expansion-panel-header {
      height: auto;
      min-height: 48px;
      line-height: 1.4em;
    }
  }
</style>
